<!-- modal escoger -->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" class="full-width" persistent scrollable>
      <v-card class="oe-card">
        <v-card-title class="oe-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-book-open-variant</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Programas para oferta académica</div>
                <div class="text-body-2 white--text">
                  Selecciona programas universidad a nivel nacional para todas las sedes
                </div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              Seleccionados: {{ seleccionados.length }}
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-2">
          <v-divider class="mb-4" />
          <v-row dense>
            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-2 mb-2">Datos de la oferta</div>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      label="* Nombre de la oferta académica"
                      v-model.trim="input.nombre_oferta"
                      dense
                      outlined
                      prepend-icon="mdi-file"
                      type="text"
                      placeholder="Ej. Oferta 2026-I"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="xmeses"
                      v-model="input.mes"
                      label="* Mes de la oferta"
                      item-value="id"
                      dense
                      outlined
                      prepend-icon="mdi-calendar"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="* Año de la oferta"
                      v-model.number="input.anio"
                      dense
                      outlined
                      prepend-icon="mdi-calendar"
                      type="number"
                    />
                  </v-col>
                </v-row>
              </v-card>

              <v-card outlined class="pa-3 mt-3">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="text-subtitle-2">Programas universidad seleccionados</div>
                  <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
                    {{ seleccionados.length }} items
                  </v-chip>
                </div>
                <v-data-table
                  :headers="xheaders_punis"
                  :items="seleccionados"
                  item-key="id"
                  disable-pagination
                  hide-default-footer
                  dense
                  class="elevation-1"
                  no-data-text="No hay programas seleccionados"
                >
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                      {{ item.estado }}
                    </v-chip>
                  </template>
                  <template v-slot:item.programas="{ item }">
                    <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3" @click="$refs.refmodalVerProgs_esam.openmodal(item)">
                      {{ item.programas ? item.programas.length : 0 }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="text-subtitle-2">Buscar programas universidad:</div>
                  <v-btn text small :loading="loading_progs" @click="listar_programas_universidad()">
                    Actualizar
                  </v-btn>
                </div>
                <v-text-field
                  v-model="search_programa"
                  append-icon="mdi-magnify"
                  prepend-inner-icon="mdi-filter-variant"
                  label="Buscar programas universidad"
                  clearable
                  single-line
                  outlined
                  dense
                  class="search-field"
                  hide-details="auto"
                  @keyup.enter="listar_programas_universidad()"
                  @click:append="listar_programas_universidad()"
                />
                <v-data-table
                  v-model="seleccionados"
                  :headers="xheaders_punis"
                  :items="programas_uni"
                  :loading="loading_progs"
                  item-key="id"
                  show-select
                  disable-pagination
                  hide-default-footer
                  dense
                  class="elevation-1"
                  no-data-text="No hay resultados"
                >
                  <template v-slot:item.programaNombre="{ item }">
                    <div>
                      <div>{{ item.programaNombre }}</div>
                      <div class="caption grey--text">{{ item.areaUniversidad.nombre }}</div>
                    </div>
                  </template>
                  <template v-slot:item.programas="{ item }">
                    <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3" @click="$refs.refmodalVerProgs_esam.openmodal(item)">
                      {{ item.programas ? item.programas.length : 0 }}
                    </v-chip>
                  </template>
                  <template v-slot:item.ceubArchivoId="{ item }">
                    <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                      {{ item.ceubArchivoId ? 'si' : 'no' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                      {{ item.estado }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="teal" text @click="$refs.modalListaEscogidos.openmodal()">
            <v-icon left small>mdi-history</v-icon>
            Ver historial
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
          <v-btn color="teal darken-2" class="white--text" :loading="loading" @click="enviar()">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar selección
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <modal-confirmar-escoger ref="modalConfirmarEscoger" />
    <modal-lista-escogidos ref="modalListaEscogidos" />
    <modalVerProgs_esam ref="refmodalVerProgs_esam" />
  </div>
</template>

<script> 
import {meses,headers_punis} from './utils';
import ProgramaUniversidadService from '../../pagos/services/programa-universidad.service';
import modalConfirmarEscoger from './modal-confirmar-escoger.vue';
import modalListaEscogidos from './modal-lista-escogidos.vue';
import modalVerProgs_esam from './modal-ver-progs_esam.vue';

  export default {
    components: { modalConfirmarEscoger, modalListaEscogidos,modalVerProgs_esam },
    data() {
      return {
        loading: true,
        loading_progs: false,
        dialog: false,  
        programas_uni: [],
        seleccionados: [],
        xheaders_punis: [],
        xmeses: [],
        search_programa: '',
        input:{
            nombre_oferta:'',
            mes: null,
            anio: new Date().getFullYear(),
        }
      };
    },
    computed: {
    },
    methods: {
      mesTexto(mesId) {
        const m = this.xmeses.find(x => x.id === mesId);
        return m ? m.text : mesId;
      },
      async openmodal() {  
        this.loading = false;
        this.dialog = true;
        this.seleccionados = []
        this.input.nombre_oferta = '';
        this.input.mes = new Date().getMonth();
        this.search_programa = ''
        this.input.anio = new Date().getFullYear();
        this.xmeses = meses();
        this.xheaders_punis = headers_punis();

        this.listar_programas_universidad()
      },
      async listar_programas_universidad() {
        const opciones = { params:{estado:'pendiente'} }
        if(this.search_programa) opciones.params.busqueda = this.search_programa;

        this.loading_progs = true;
        const res = await ProgramaUniversidadService.findAllPaginado(opciones)
        this.loading_progs = false;
        // window.console.log('resss',res);
        this.programas_uni = res.data.datos;
        
      },
      cerrar() {
        this.dialog = false;
      },
      
      async enviar() {
        if(!this.input.nombre_oferta || !this.input.mes || !this.input.anio || this.seleccionados.length == 0) {
          this.$root.$notify.show('Complete todos los campos requeridos', {
            color: 'red',
            x: 'right',
          });
          return;
        }
        const seles = this.seleccionados.map(s=> ({
          id: s.id,
          codigo: s.codigo,
          programaNombre: s.programaNombre,
          areaUniversidad: s.areaUniversidad,
          sedeUniversidad: s.sedeUniversidad.institucion.nombre,
          estado: s.estado,
          ceubArchivoId: s.ceubArchivoId,
          programas: s.programas.map(p=>({id:p.id, codigo:p.codigo, nombreCompuesto: p.nombreCompuesto})),
        }));
        const seles_json = JSON.stringify(seles);
        const confirmar = await this.$refs.modalConfirmarEscoger.openmodal({
          oferta: {
            nombre_oferta: this.input.nombre_oferta,
            mes_texto: this.mesTexto(this.input.mes),
            anio: this.input.anio
          },
          seleccionados: seles
        });
        if(!confirmar) return;
        
        const datos = {
          seleccionados_por: this.$store.state.DATA_USER.id,
          nombre_oferta:this.input.nombre_oferta,
          mes: this.input.mes,
          anio: this.input.anio,
          seleccionados: seles_json,
        }
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        const graphql = JSON.stringify({
          query: "mutation save_escogidos($input:NewEscogidos!){ save_escogidos(input:$input){id fecha_registro} }",
          variables: {"input":datos}
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };
        
        this.loading = true;
        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        this.loading = false;
        window.console.log('res',res);
        if(res && res.save_escogidos){
          this.$root.$notify.show('Lista guardada', {
            color: 'green',
            x: 'right',
          });
          this.cerrar()
        }
      }, 
    },
  };
</script>

<style scoped>
.oe-card {
  border-radius: 14px;
  overflow: hidden;
}
.oe-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
.search-field {
  background: #f6fbfa;
  border-radius: 10px;
}
</style>
